import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import { setDiffMode } from 'flow/store/redux/slice';
import { selectDiffMode, selectSnippetMode } from 'flow/store/redux/selectors';
import { useEditorAccess } from 'flow/editor/context';
import { EditorMode } from 'flow/editor/context/constants';
import { getIsEditable, getIsReadOnly } from 'flow/service/general';

/**
 * Toggleable function that turns on the isInDiffMode redux state, and sets
 * the editor mode to read-only only if we are not in a snippet mode (upgrade,
 * merge, etc...)
 */
export function useHandleDiffMode() {
  const dispatch = useAppDispatch();
  const isInDiffMode = useAppSelector(selectDiffMode);
  const isInSnippetMode = useAppSelector(selectSnippetMode);
  const { setEditorMode, resetEditorMode } = useEditorAccess();
  const { editorMode } = useEditorAccess();
  const inEditMode = getIsEditable(editorMode);
  const inReadOnlyMode = getIsReadOnly(editorMode);

  return () => {
    const shouldEnableDiffMode = !isInDiffMode;
    if (!isInSnippetMode && (inEditMode || inReadOnlyMode)) {
      dispatch(setDiffMode(shouldEnableDiffMode));

      if (shouldEnableDiffMode) {
        setEditorMode(EditorMode.ReadOnly);
      } else {
        resetEditorMode();
      }
    }
  };
}
